
import SupplementItemList from './ManageSupplement/Item/List.vue'
import SupplementItemAdd from './ManageSupplement/Item/Add.vue'
import SupplementItemEdit from './ManageSupplement/Item/Edit.vue'
import SupplementItemRemark from './ManageSupplement/Item/Remark'

import SupplementTypeList from './ManageSupplement/Type/List.vue'
import SupplementTypeAdd from './ManageSupplement/Type/Add.vue'
import SupplementTypeEdit from './ManageSupplement/Type/Edit.vue'

export default [
  {
    path: 'item',
    name: 'HotelSupplementItemList',
    component: SupplementItemList
  },
  {
    path: 'item/add',
    name: 'HotelSupplementItemAdd',
    props: true,
    component: SupplementItemAdd
  },
  {
    path: 'item/edit',
    name: 'HotelSupplementItemEdit',
    props: true,
    component: SupplementItemEdit
  },
  {
    path: 'item/remark',
    name: 'HotelSupplementItemRemark',
    props: true,
    component: SupplementItemRemark
  },
  {
    path: 'type',
    name: 'HotelSupplementTypeList',
    component: SupplementTypeList
  },
  {
    path: 'type/add',
    name: 'HotelSupplementTypeAdd',
    component: SupplementTypeAdd
  },
  {
    path: 'type/edit',
    name: 'HotelSupplementTypeEdit',
    props: true,
    component: SupplementTypeEdit
  }
]
